
const pricingQuestions = [
  'كيف يتم احتساب تكلفة النقل في منصة شحن؟',
  'هل يتم تطبيق ضريبة القيمة المضافة على فواتير النقل؟',
  'هل الفوترة تتم لكل رحلة على حدة أم بفاتورة مجمعة؟',
  'هل يمكن تقسيم الفواتير بحسب الفروع أو المدن أو نوع البضاعة؟',
  'هل توجد رسوم على إلغاء الطلب؟',
  'هل هناك رسوم على التأخير أو المبيت؟',
  'هل يمكن ربط المحفظة الإلكترونية للشركة مع نظام الفوترة؟',
  'هل توفر شحن خيار الدفع الآجل للشركات؟',
  'ما هي طرق الدفع المتاحة في منصة شحن؟',
];

const pricingAnswers = [
  'يتم احتساب السعر آليًا عبر المنصة بناءً على المسافة بين موقع التحميل والتسليم ونوع الشاحنة المطلوبة. للشركات التي لديها وجهات ثابتة أو معدلات طلب عالية، يمكن إعداد تسعير خاص بعقود طويلة الأمد تضمن استقرار الأسعار ووضوح التكاليف التشغيلية.',
  'نعم، جميع الفواتير الصادرة من شحن خاضعة لضريبة القيمة المضافة بنسبة 15٪، وتصدر إلكترونيًا ومتوافقة مع متطلبات هيئة الزكاة والضريبة والجمارك.',
  'يتم إصدار الفواتير وفق نوع التعاقد. للعملاء بعقود الدفع الآجل، تصدر شحن فاتورة مجمعة تشمل جميع الرحلات خلال فترة الائتمان المتفق عليها. أما العملاء غير المتعاقدين بعقود آجلة، فتُصدر فاتورة مستقلة لكل رحلة منفذة.',
  'نعم، يمكن إصدار فواتير مقسّمة وفق طلب العميل وبالشكل الذي يناسب أعماله. على سبيل المثال، يمكن تخصيص فاتورة مجمعة لكل فرع (الدمام، جدة، الرياض) أو تقسيم الفواتير حسب نوع البضاعة — مثل فواتير منفصلة لنقل المواد الخام عن فواتير نقل المنتجات النهائية أو بضائع المعارض.',
  'نعم، تطبق رسوم إلغاء وفق الشروط والأحكام المعتمدة في سياسة الاستخدام الخاصة بمنصة شحن.',
  'نعم، تُطبق رسوم إضافية على التأخير والمبيت حسب نوع الشاحنة ومدة الانتظار، وفق ما هو موضح في الشروط والأحكام.',
  'نعم، يمكن ربط المحفظة الإلكترونية الخاصة بالعميل مباشرة مع نظام الفوترة في شحن، حيث يتم خصم مبالغ الرحلات تلقائيًا من الرصيد المتاح.',
  'نعم، يمكن للشركات المؤهلة التمتع بخدمة الدفع الآجل ضمن عقود رسمية، وفقًا لشروط محددة تتعلق بحجم الطلبات وانتظام العمليات التشغيلية.',
  'توفر شحن خيارات دفع متعددة تشمل: التحويل البنكي، بطاقات مدى والفيزا والماستر كارد، Apple Pay، STC Pay، إضافة إلى خيار شحن المحفظة المخصصة للشركات.',
];

const transportQuestions = [
  'ما هي أنواع الشاحنات المتوفرة في شحن؟',
  'هل تقدم شحن خدمات النقل من وإلى الموانئ؟',
  'هل تقدم شحن خدمات النقل البري الدولي؟',
  'هل يمكن نقل البضائع الصغيرة أو الشحن بالقطعة أو بالوزن؟',
  'هل يمكن تحميل أكثر من موقع في رحلة واحدة؟',
  'هل يمكنني إضافة أكثر من موقع تحميل؟',
  'هل يمكن تحميل البضائع في يوم الجمعة أو خارج ساعات العمل الرسمية؟',
];
const transportAnswers = [
  'توفر شحن أسطولًا متنوعًا يشمل التريلات، السقوس، اللوريات، الديانات، والبيك أب، بجميع أنواعها (سطحة، ستارة، مبردة، جوانب عالية، جوانب ألماني) لتلبية جميع احتياجات النقل البري للشركات.',
  'نعم، تدير شحن عمليات نقل الحاويات والبضائع من وإلى الموانئ داخل المملكة، بما في ذلك التنسيق مع شركات التخليص الجمركي وضمان التسليم في الوقت المحدد.',
  'تقدم شحن خدمات النقل البري إلى الدول المجاورة ضمن التزامات تنظيمية وتأمينية كاملة، مع إدارة عمليات التصدير والاستيراد بسلاسة وموثوقية.',
  'في شحن، نوفر خدمة تأجير الشاحنة بالكامل للعميل بحيث يتم تخصيص شاحنة كاملة لنقل البضائع المطلوبة. لا نوفر خدمة النقل الجزئي أو الشحن بالوزن أو بالقطعة أو للمقتنيات الشخصية.',
  'نعم، يمكن تنفيذ الرحلات متعددة النقاط (Multi-stop Trips) حسب طلب العميل، ويتم احتساب السعر آليًا وفق المسافة الإجمالية وعدد المحطات.',
  'نعم، يمكن إضافة عدة مواقع تحميل وتسليم.',
  'يمكن تنفيذ الطلبات في أي وقت بناءً على التنسيق المسبق مع فريق التشغيل أو بموجب عقد خاص ينص على التشغيل خارج ساعات العمل الرسمية.',
];

const businessAndContractsQuestions = [
  'هل يمكن التعاقد مع شحن بعقود طويلة الأمد؟',
  'هل يمكن تخصيص منسق ميداني لإدارة النقل من موقع الشركة؟',
  'هل يمكن إرسال موظف لإدارة عمليات النقل من موقعنا؟',
  'ما هي مهام مدير حساب الشركة المخصص؟',
  'لدينا معدل طلبات يومي كبير، هل يمكن رفع الطلبات بطريقة أسهل من إدخالها يدويًا؟',
];

const businessAndContractsAnswers = [
  'نعم، تقدم شحن عقود نقل سنوية أو نصف سنوية للشركات، تضمن توفر الشاحنات واستقرار الأسعار وجودة التشغيل في جميع الرحلات.',
  'نعم، توفر شحن هذه الخدمة للشركات ذات الطلب اليومي المرتفع أو العقود الثابتة، حيث يتم تعيين منسق لوجستي ميداني لإدارة حركة الشاحنات والإشراف على التحميل والتسليم.',
  'نعم، توفر شحن خدمة منسق الحركة الميداني للعملاء ذوي العمليات اليومية الثابتة، للإشراف المباشر على التحميل والتسليم وإدارة الجداول التشغيلية.',
  'مدير الحساب مسؤول عن رفع الطلبات نيابة عن الشركة، وجدولة الرحلات حسب خطة التشغيل، ومتابعة حركة النقل ومواقع السائقين، وتزويد العميل بالتقارير التشغيلية والفواتير، إضافةً إلى تقديم الدعم والمتابعة المستمرة على مدار الساعة.',
  'نعم، يمكن تزويد مدير الحساب بجدول الرحلات اليومي ليقوم برفع الطلبات نيابة عن العميل. كما يمكن ربط نظام العميل تقنيًا بمنصة شحن لتسهيل رفع الطلبات بشكل آلي.',
];

const shipmentAndTrackingQuestions = [
  'كيف يمكن للشركات تتبع الشاحنات؟',
  'هل يمكن للعميل تتبع السائق لحظة بلحظة عبر الخريطة؟',
  'هل يمكن متابعة حالة الطلبات السابقة والأرشيفية؟',
  'هل يمكن جدولة الطلبات مسبقًا؟',
  'هل يمكن إلغاء أو تعديل الطلب بعد رفعه؟',
  'هل الطلب الذي أرفعه عبر التطبيق أو الموقع الإلكتروني مؤكد؟',
  'هل يمكن إرجاع أصل إذن التسليم بعد توقيعه وختمه من المستلم؟',
  'هل يمكن الحصول على نسخة إلكترونية من إذن التحميل وإذن التسليم؟',
];

const shipmentAndTrackingAnswers = [
  'يمكن تتبع الشاحنات والرحلات في جميع مراحلها من خلال المنصة أو التطبيق، حيث يتم تحديث حالة الطلب لحظيًا مع إشعارات فورية لضمان وضوح العمليات التشغيلية.',
  'نعم، تتيح منصة شحن تتبع السائق عبر خريطة مباشرة محدثة لحظة بلحظة مع عرض حالة الطلب والوقت المقدر للوصول.',
  'نعم، يمكن عرض جميع الطلبات السابقة والمنفذة عبر لوحة التحكم في المنصة مع إمكانية تنزيل تقارير الأداء والتكاليف السابقة.',
  'نعم، يمكن للعميل تحديد مواعيد مستقبلية لرحلاته وجدولتها مسبقًا لتسهيل التخطيط اللوجستي وضمان توفر الشاحنات.',
  'نعم، يمكن تعديل أو إلغاء الطلب قبل بدء التنفيذ، وفق الشروط والأحكام المعتمدة، وفي حال التنفيذ الجزئي قد تُطبق رسوم محددة.',
  'نعم، جميع الطلبات التي تُرفع عبر المنصة تُعد مؤكدة ويتم تنفيذها فورًا من قبل فريق التشغيل في شحن.',
  'نعم، يمكن إرجاع أصل إذن التسليم للعميل عند الطلب، ويتم التنسيق لذلك من خلال مدير الحساب أو فريق خدمة العملاء.',
  'نعم، يمكن تحميل جميع مستندات الرحلات (إذن التحميل وإذن التسليم) بصيغة رقمية من خلال لوحة التحكم أو من خلال مدير الحساب.',
];

const accountAndAccessQuestions = [
  'فتحت حساب أفراد بدلاً من حساب شركات، هل يمكن تعديل نوع الحساب؟',
  'هل يمكن تخصيص صلاحيات مختلفة لموظفي شركتي داخل حساب واحد؟',
];
const accountAndAccessAnswers = [
  'نعم، يمكن تعديل نوع الحساب إلى حساب شركات عبر التواصل مع فريق الدعم المخصص لشحن من خلال القنوات الرسمية المعلنة.',
  'نعم، يمكن منح صلاحيات مختلفة لموظفي الشركة داخل الحساب الواحد مثل صلاحية رفع الطلبات، مراجعة الفواتير، أو عرض التقارير فقط، حسب سياسة العميل.',
];

const platformAndIntegrationQuestions = [
  'هل يمكن ربط نظام شركتنا بمنصة شحن؟',
  'كيف يمكن إرسال أو رفع الطلبات عبر منصة شحن؟',
];

const platformAndIntegrationAnswers = [
  'نعم، تتيح شحن تكاملًا تقنيًا (API Integration) مع أنظمة ERP وSAP لدى الشركات، مما يسهّل رفع الطلبات وتتبع الرحلات والفواتير بشكل مباشر وآلي.',
  'يمكن للعملاء رفع الطلبات مباشرة عبر تطبيق شحن أو الموقع الإلكتروني، أو من خلال مدير الحساب أو فريق خدمة العملاء للشركات.',
];

const reportingAndInsightsQuestions = [
  'هل تقدم شحن خدمة تقارير تشغيلية أو مالية؟',
  'هل يمكن إصدار تقارير تشغيلية شهرية لحركة النقل والفواتير؟',
  'هل يمكن تزويدنا بتقرير يحتوي على أرقام أذون التسليم الشهرية مع الفاتورة؟',
  'هل توفر شحن تقارير أداء خاصة بكل فرع؟',
];

const reportingAndInsightsAnswers = [
  'نعم، يمكن للشركات الوصول إلى تقارير التشغيل والفواتير وكشوف الحساب مباشرة من خلال المنصة الإلكترونية الخاصة بها لمتابعة الأداء المالي والتشغيلي بدقة.',
  'نعم، يمكن إصدار تقارير شهرية مفصلة تتضمن عدد الرحلات، المدن المشغلة، أنواع الشاحنات، وقيم الفواتير الإجمالية والمستحقة، مما يساعد العميل على متابعة الأداء بدقة.',
  'نعم، يمكن إصدار تقرير تفصيلي يتضمن أرقام أذون التسليم (Delivery Notes) لجميع الرحلات المنفذة خلال فترة الفاتورة المجمعة، ويرسل مع الفاتورة النهائية.',
  'نعم، يمكن إعداد تقارير تشغيلية ومالية منفصلة لكل فرع داخل المؤسسة، مما يسهل المراجعة المالية والتخطيط الاستراتيجي.',
];

const policiesAndRegulationsQuestions = [
  'ما هي المدة القصوى لتحميل الشحنة أو الانتظار في موقع العميل؟',
  'ما هي سياسة شحن في حال حدوث تلف أو ضرر للبضاعة؟',
  'هل يتم تأمين البضائع المنقولة عبر شحن؟',
  'هل يمكن تحديد جنسية السائق لأسباب دخول المواقع الحساسة أو الحكومية؟',
  'هل تصدر منصة شحن وثيقة نقل رسمية لكل رحلة؟',
  'هل بيانات شركتي ومعلومات الشحنات محمية؟',
  'هل منصة شحن مرخصة من هيئة النقل؟',
];

const policiesAndRegulationsAnswers = [
  'توفر شحن فترات انتظار محددة ضمن السعر، ويمكن تمديدها مقابل رسوم إضافية يتم فوترتها بعد اكتمال الطلب حسب نوع الشاحنة ومدة الانتظار.',
  'يتم التعامل مع أي ضرر وفق شروط التأمين المعتمدة، حيث يُرفع بلاغ رسمي ويتم تعويض العميل حسب قيمة البضاعة المؤمن عليها.',
  'نعم، يتم تأمين جميع الشحنات المنفذة عبر منصة شحن حسب قيمة البضاعة المنقولة، وتشمل الخدمة توثيقًا رقميًا لإثباتات التحميل والتسليم لحفظ الحقوق وضمان الشفافية.',
  'نعم، يمكن توفير سائقين بجنسيات محددة وفقًا لمتطلبات موقع التحميل أو السياسات الأمنية للمنشآت الحكومية أو الصناعية.',
  'نعم، تصدر منصة شحن وثيقة نقل إلكترونية رسمية لكل رحلة نقل عبر منصة «لوجستي» التابعة لهيئة النقل.',
  'نعم، تلتزم شحن بحماية جميع بيانات العملاء ومعاملاتهم من خلال أنظمة أمن معلومات متقدمة، وتُعد سرية البيانات التزامًا أساسيًا غير قابل للتفاوض.',
  'نعم، منصة شحن مرخصة رسميًا من الهيئة العامة للنقل برقم الترخيص 29/00000747 وتعمل وفق الأنظمة واللوائح المنظمة للنقل البري في المملكة.',
];

const companyInfoQuestions = ['من هي الشركة المالكة لمنصة شحن؟'];

const companyInfoAnswers = [
  'شحن مملوكة لشركة فكر للاتصالات وتقنية المعلومات، وهي شركة سعودية مرخصة تعمل في مجال الحلول الرقمية للنقل والخدمات اللوجستية.',
];

export const _faqsArSupport = {
  pricingAndBilling: pricingQuestions.map((question, i) => ({
    id: new Date().getTime() + i,
    question,
    answer: pricingAnswers[i],
  })),
  transportServices: transportQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 10, // add offset so IDs stay unique
    question,
    answer: transportAnswers[i],
  })),
  businessAndContracts: businessAndContractsQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 20,
    question,
    answer: businessAndContractsAnswers[i],
  })),
  shipmentAndTracking: shipmentAndTrackingQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 30,
    question,
    answer: shipmentAndTrackingAnswers[i],
  })),
  accountAndAccess: accountAndAccessQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 40,
    question,
    answer: accountAndAccessAnswers[i],
  })),
  platformAndIntegration: platformAndIntegrationQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 50,
    question,
    answer: platformAndIntegrationAnswers[i],
  })),
  reportingAndInsights: reportingAndInsightsQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 60,
    question,
    answer: reportingAndInsightsAnswers[i],
  })),
  policiesAndRegulations: policiesAndRegulationsQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 70,
    question,
    answer: policiesAndRegulationsAnswers[i],
  })),
  companyInfo: companyInfoQuestions.map((question, i) => ({
    id: new Date().getTime() + i + 80,
    question,
    answer: companyInfoAnswers[i],
  })),
};
